export function parseJsonMessage(content, variables, message = '') {
  return content
    .reduce((acc, { type, text, attrs, content: nestedContent }) => {
      if (['paragraph'].includes(type)) {
        return parseJsonMessage(nestedContent, variables, `${acc}\n`);
      }

      if (type === 'text') {
        return `${acc}${text}`;
      }

      if (type === 'variable') {
        const variable = variables[attrs.type] || attrs.fallback;
        return `${acc}${variable}`;
      }

      return acc;
    }, message)
    .trim();
}

export function parseHtml(content, variables) {
  const matches =
    content.match(
      /<variable type="[A-Za-z]*" fallback="[^<>]*"><\/variable>/g
    ) || [];

  return matches.reduce((message, tag) => {
    const type = tag.match(/type="([^<> ]*)"/)[1];
    const fallabck = tag.match(/fallback="([^<> ]*)"/)?.[1] || '';
    let value = variables[type] || fallabck;

    if (type === 'listUrl') {
      value = `<a href="${value}" alt="list link">${value}</a>`;
    }
    return message.replace(tag, value);
  }, content);
}

export const PLAIN_TEXT_OPTS = {
  blockSeparator: ' ',
  textSerializers: {
    variable: ({ node }) => {
      const {
        attrs: { type, fallback = '' },
      } = node;
      return `<variable type="${type}" fallback="${fallback}"></variable>`;
    },
  },
};

const BUBBLE_TOP_INSET = 110;
const BUBBLE_BOTTOM_INSET = 68;
const BUBBLE_EDGE_INSET = 4;

export function bubblePopperOptions(editor) {
  const { left, right } = editor.options.element.getBoundingClientRect();

  const padding = {
    top: BUBBLE_TOP_INSET,
    bottom: BUBBLE_BOTTOM_INSET,
    left: left + BUBBLE_EDGE_INSET,
    right: document.documentElement.clientWidth - right + BUBBLE_EDGE_INSET,
  };

  return {
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          rootBoundary: 'viewport',
          padding,
          altAxis: true,
          tether: false,
        },
      },
      { name: 'flip', options: { rootBoundary: 'viewport', padding } },
      { name: 'eventListeners', options: { scroll: true, resize: true } },
    ],
  };
}

export function applyBubbleBoundary(editor) {
  return (instance) => {
    instance.setProps({ popperOptions: bubblePopperOptions(editor) });
  };
}

// keep in sync with @valid_schemes in apps/backend/lib/util/html/rte_scrubber.ex
const LINK_SCHEMES = ['http:', 'https:', 'mailto:', 'tel:'];

export function hasAllowedLinkScheme(url) {
  const [scheme] =
    url
      .trim()
      .toLowerCase()
      .match(/^[a-z][a-z0-9+.-]*:/) || [];

  return !scheme || LINK_SCHEMES.includes(scheme);
}
